import { createContext, useContext } from 'react'

/**
 * Context, hook, and error type for transaction-PIN step-up. Kept apart from the
 * provider component so `useStepUp.tsx` exports components only (react-refresh).
 */

export interface StepUpContextValue {
  /** Resolves with the entered PIN, or rejects if the user dismisses the prompt. */
  requestPin: (reason?: 'required' | 'invalid') => Promise<string>
}

export class StepUpCancelledError extends Error {
  constructor() {
    super('Transaction cancelled')
    this.name = 'StepUpCancelledError'
  }
}

export const StepUpContext = createContext<StepUpContextValue | null>(null)

export function useStepUp(): StepUpContextValue {
  const context = useContext(StepUpContext)
  // Callers outside the provider (isolated tests, storybook) simply get no
  // step-up prompt; the underlying 403 then surfaces as an ordinary error.
  return (
    context ?? {
      requestPin: () => Promise.reject(new StepUpCancelledError()),
    }
  )
}
